/* eslint-disable @typescript-eslint/consistent-indexed-object-style */
function capitalize(s) {
    return (s[0].toUpperCase() + s.slice(1));
}
export function getCrudOperationNames(nodeName, pluralNodeName) {
    const capitalizedNodeName = capitalize(nodeName);
    const capitalizedPluralNodeName = capitalize(pluralNodeName);
    return {
        getOne: nodeName,
        setOne: `set${capitalizedNodeName}`,
        createOne: `create${capitalizedNodeName}`,
        deleteOne: `delete${capitalizedNodeName}`,
        getList: pluralNodeName,
        getAll: `all${capitalizedPluralNodeName}`,
        getMultiple: `getMultiple${capitalizedPluralNodeName}`,
        createMultiple: `create${capitalizedPluralNodeName}`,
        deleteMultiple: `delete${capitalizedPluralNodeName}`,
        setMultiple: `set${capitalizedPluralNodeName}`,
    };
}
//# sourceMappingURL=standardResolver.js.map